export const debounce = <Args extends unknown[]>(
  callback: (...args: Args) => void,
  wait: number
) => {
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  return (...args: Args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => callback(...args), wait)
  }
}
